module.exports = __webpack_public_path__ + "static/media/Q4-Emotional_challenge.cf0ad55b.svg";